const DataAction  = (data)=> async dispatch=>{

    try{
        if(data!=null && data!=undefined){
            dispatch({
                type:'DATA',
                payload:{data:data}
            })
        }
    }catch(err){
        console.log(err)
        dispatch({
            type:"FAIL"
        })
    }

}
export default DataAction;